var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessibilityTrigger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.66667C5.63333 2.66667 5.31944 2.53611 5.05833 2.275C4.79722 2.01389 4.66667 1.7 4.66667 1.33333C4.66667 0.966667 4.79722 0.652778 5.05833 0.391667C5.31944 0.130556 5.63333 0 6 0C6.36667 0 6.68056 0.130556 6.94167 0.391667C7.20278 0.652778 7.33333 0.966667 7.33333 1.33333C7.33333 1.7 7.20278 2.01389 6.94167 2.275C6.68056 2.53611 6.36667 2.66667 6 2.66667ZM4 13.3333V4.66667H0V3.33333H12V4.66667H8V13.3333H6.66667V9.33333H5.33333V13.3333H4Z",
    fill: "#B7E4C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibilityTrigger);
export default __webpack_public_path__ + "static/media/accessibility-trigger.743c52d071210292370032dc7b1ada7c.svg";
export { ForwardRef as ReactComponent };